import React from 'react';
import useBlocks from '../use-blocks';
import getBlock from '../get-block';
import Column from '../../column';
import Wrapper from './wrapper';
import { ConditionalContentThemeProvider } from '../../content-theme';

const ColumnBlock = ({
  columnWidth,
  align,
  justify,
  order,
  card,
  visibleFrom,
  column,
  offset,
}) => {
  const blockComponents = useBlocks(column?.blocks, getBlock);
  if (!column) {
    return null;
  }
  return (
    <ConditionalContentThemeProvider contentTheme={column.contentTheme}>
      <Column
        columnWidth={columnWidth}
        align={align}
        justify={justify}
        card={card}
        order={order}
        background={column.background}
        offset={offset}
        $visibleFrom={visibleFrom}
      >
        <Wrapper $columnWidth={columnWidth}>
          {blockComponents}
        </Wrapper>
      </Column>
    </ConditionalContentThemeProvider>
  );
};

export default ColumnBlock;
